import { render, staticRenderFns } from "./AddScoreForm.vue?vue&type=template&id=75150e28&"
import script from "./AddScoreForm.vue?vue&type=script&lang=js&"
export * from "./AddScoreForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports